import { GridColumnType } from "../../../../data/gridColumnType";

export const DecisionCardConfig = {
  columns: [
    {
      name: "Name",
      fieldName: "adminName",
      allowShort: false,
      colType: GridColumnType.Text,

    },
    {
      name: "Decision",
      fieldName: "decision",
      allowShort: false,
      colType: GridColumnType.Text,

    },
    // {
    //   name: "Decision Date",
    //   fieldName: "decisionDate",
    //   allowShort: false,
    //   colType: GridColumnType.DATE,
    //   colSettings: {
    //     format: 'DD MMM YYYY',
    //   }
    // },
    {
      name: "Comments",
      fieldName: "internalComments",
      allowShort: false,
      colType: GridColumnType.Text,
    },
  ],
};
